import React from "react";
import MultiSelect from "@/components/MultiSelect";
import Select from "@/components/Select";
import FilterActions from "@/components/FilterActions";

export const MONTHS = ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"];

// `f` = useFilters: alegerile stau în `f.draft` și se aplică abia la „Aplică filtre”.
export default function TimeentriesFilters({ f, employmentOptions, structures, categories }) {
  const filters = f.draft;
  const thisYear = new Date().getFullYear();
  const set = (patch) => f.set(patch);
  return (
    <form className="te-filters" data-testid="te-filters" onSubmit={e => { e.preventDefault(); f.apply(); }}>
      <div style={{ minWidth: 240 }}>
        <label className="label">Rapoarte de muncă</label>
        <MultiSelect options={employmentOptions} value={filters.employmentIds} onChange={v => set({ employmentIds: v })}
          allLabel="Toate" testId="te-filter-employments" minWidth={240} />
      </div>
      <div>
        <label className="label">Lună</label>
        <Select className="select" value={filters.month} onChange={e => set({ month: Number(e.target.value) })} data-testid="te-filter-month">
          {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
        </Select>
      </div>
      <div>
        <label className="label">An</label>
        <Select className="select" value={filters.year} onChange={e => set({ year: Number(e.target.value) })} data-testid="te-filter-year">
          {[...new Set([thisYear - 1, thisYear, thisYear + 1, filters.year])].sort().map(y => <option key={y} value={y}>{y}</option>)}
        </Select>
      </div>
      <div style={{ minWidth: 200 }}>
        <label className="label">Structura organizatorică</label>
        <MultiSelect options={structures.map(x => ({ value: x.id, label: x.name }))} value={filters.structureIds}
          onChange={v => set({ structureIds: v, employmentIds: [] })} allLabel="Toate" testId="te-filter-structure" minWidth={200} />
      </div>
      <div style={{ minWidth: 200 }}>
        <label className="label">Categorie de personal</label>
        <MultiSelect options={categories} value={filters.categories}
          onChange={v => set({ categories: v, employmentIds: [] })} allLabel="Toate" testId="te-filter-category" minWidth={200} />
      </div>
      <FilterActions f={f} testid="te-filters" />
    </form>
  );
}
